<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : activeStep == step }" (click)="toggleOpen()">
        <span class="margin-right">Payment Option - if applicable</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell small-6 medium-7 large-7 bold">
      Choose an option from the list.  If you have questions, please contact the Division.<span [ngClass]="{ 'red': form?.get('option')?.invalid }">*</span>
      @if (fieldHasNotes('payments|option') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'payments|option'" [notes]="getFilteredNotes('payments|option')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-3 medium-3 large-3">
      <select formControlName="option" (ngModelChange)="paymentOptionChanged($event)">
        @for (opt of options; track opt) {
          <option [value]="opt.id">{{opt.text}}</option>
        }
      </select>
    </div>
    <div class="cell small-3 medium-2 large-2">&nbsp;</div>
    <div class="cell small-6 medium-7 large-7 bold">
      How do you wish to pay?
      @switch (selectedOption) {
        @case ('none') {
          <span class="red">
            Not applicable
          </span>
        }
        @case ('') {
          <span>&nbsp;</span>
        }
        @default {
          <span [ngClass]="{ 'red': form?.get('paymentType')?.invalid }">*</span>
        }
      }
    </div>
    <div class="cell small-3 medium-3 large-3">
      <select formControlName="paymentType" (ngModelChange)="paymentTypeChanged($event)">
        @for (opt of paymentService.paymentTypes; track opt) {
          <option [value]="opt.value">{{opt.name}}</option>
        }
      </select>
    </div>
    <div class="cell small-3 medium-2 large-2 padding-left">
      <button class="button" (click)="requestAuthorization()" [disabled]="disablePaymentButton">Select Payment</button>
    </div>
    @if (showInvoice) {
      <invoice [fees]="fees" [authorization]="authorization" [config]="config?.permits?.documents" [documentId]="existingDocumentId" [paymentType]="selectedPayment" (receiptIssued)="onReceiptIssued($event)" (newResponseReceived)="saveNewResponse($event)"></invoice>
    }
  </div>
</ng-container>
